function CountryComponent($http, AppConstants) {
	'ngInject';

	const service = {
		fetchCountries: fetchCountries,
		fetchCountry: fetchCountry,
		getCountries: getCountries,
		getCountry: getCountry,
		clearCountries: clearCountries
	};

	let countries = [];
	let country = {};

	return service;

	function fetchCountries(value = '') {
		return $http.get(`${AppConstants.apiUrl}/countries`, {
			'params': {
				'page': 1,
				'per_page': AppConstants.perPage,
				'query': value
			},
			'ignoreLoadingBar': true
		})
			.then(setCountries)
			.catch(failedRequest);
	}

	function fetchCountry(id) {
		return $http.get(`${AppConstants.apiUrl}/countries/${id}`)
			.then(setCountry)
			.catch(failedRequest);
	}

	function setCountries(response) {
		countries = response.data.data;
		return countries;
	}

	function setCountry(response) {
		country = response.data.data;
		return country;
	}

	function getCountries() {
		return countries;
	}

	function getCountry() {
		return country;
	}

	function clearCountries() {
		countries = [];
		return countries;
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}

}

export default CountryComponent;



/** WEBPACK FOOTER **
 ** ./client/components/country/country.service.js
 **/